import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Sparkles } from "lucide-react";

/**
 * Auto-scrolling ticker of the most recently uploaded products.
 * Only renders once the user is signed in (Navbar checks `customer` before mounting).
 */
export default function LatestProductBanner() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/products")
      .then(r => {
        const sorted = [...r.data].sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));
        setItems(sorted.slice(0, 8));
      })
      .catch(() => {});
  }, []);

  if (items.length === 0) return null;
  // Double the list so the marquee loop is seamless
  const marquee = [...items, ...items];

  return (
    <div className="bg-[#1E2C5A] text-white overflow-hidden" data-testid="latest-product-banner">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-2.5 flex items-center gap-6">
        <div className="flex items-center gap-2 flex-shrink-0 pr-4 border-r border-white/20">
          <Sparkles className="w-3.5 h-3.5 text-[#C9A968]" strokeWidth={1.5} />
          <span className="text-[10px] uppercase tracking-[0.25em] text-[#C9A968]">Just Arrived</span>
        </div>
        <div className="flex-1 overflow-hidden relative">
          <div className="flex gap-10 whitespace-nowrap animate-marquee" style={{ animationDuration: `${items.length * 6}s` }}>
            {marquee.map((p, i) => (
              <Link
                key={`${p.id}-${i}`}
                to={`/product/${p.id}`}
                className="inline-flex items-center gap-3 text-xs hover:text-[#C9A968] transition-colors flex-shrink-0"
                data-testid={`latest-banner-${p.our_code}`}
              >
                {p.image_url && (
                  <img src={p.image_url} alt={p.name} className="w-8 h-8 object-cover rounded-sm" loading="lazy" />
                )}
                <span className="uppercase tracking-wider">{p.name}</span>
                <span className="text-white/50">·</span>
                <span className="text-white/70">{p.size}</span>
                <span className="text-white/50">·</span>
                <span className="text-[#C9A968]">₹{p.offer_price}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
